import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import appConfig from "../../../config/config";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  Button,
  CardTitle,
  CardHeader,
  CardText,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import classnames from "classnames";
import {
  renderInput,
  renderTextArea,
  renderDatePicker,
  renderDropdown,
  renderMultiselect,
  renderCheckbox,
} from "../../common/renderinput";
import ContactForm from "../../common/contact";
import validate from "./validate";

class VendorEOForm extends Component {
  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        <Row form>
          <Col md={6}>
            <Card className="w-100">
            <CardHeader as="" >Errors & Omissions</CardHeader>
              <CardBody>
                <FormGroup>
                  <Field name="Holder" component={renderInput} label="Holder" />
                  <Field
                    name="Effective"
                    component={renderInput}
                    label="Effective Date"
                  />
                  <Field
                    name="Expiration"
                    component={renderInput}
                    label="Expiration Date"
                  />
                  <Field
                    name="PolicyNo"
                    component={renderInput}
                    label="Plicy No"
                  />
                  <Field name="Amount" component={renderInput} label="Amount" />
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="w-100">
            <CardHeader as="" >Contact</CardHeader>
              <CardBody>
                <ContactForm />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Card className="col-12 mb-3">
          <CardBody>
            <div className="text-right">
                <Button
                  style={{ marginRight: 16 }}
                  type="button"
                  onClick={this.props.previousPage}>
                  Previous
                </Button>
              <Button type="submit">Next</Button>
            </div>
          </CardBody>
        </Card>
      </form>
    );
  }
}
export default reduxForm({
  form: "CreateVendorForm", // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(VendorEOForm);
